import React, { useState } from 'react';
import { X } from 'lucide-react';
import useApi from '../../hooks/useApi';

const ChangeKeywordModal = ({ onClose, onSuccess }) => {
    const { apiFetch } = useApi();
    const [newRecoveryKeyword, setNewRecoveryKeyword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newRecoveryKeyword.length < 4) {
            setError('A palavra-chave deve ter pelo menos 4 caracteres.');
            return;
        }
        setError('');
        setLoading(true);

        try {
            await apiFetch('/change-recovery-keyword', {
                method: 'PUT',
                body: { newRecoveryKeyword }
            });
            onSuccess();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        // CORREÇÃO: Removido onClick={onClose} do backdrop
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div 
                className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl"
                onClick={e => e.stopPropagation()} // Previne propagação
            >
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-bold">Alterar Palavra-Chave</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200"><X /></button>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {error && <p className="p-2 text-sm text-red-700 bg-red-100 rounded">{error}</p>}
                    <div>
                        <label className="block text-sm font-medium">Nova Palavra-Chave de Recuperação</label>
                        <input type="text" value={newRecoveryKeyword} onChange={e => setNewRecoveryKeyword(e.target.value)} required className="w-full p-2 mt-1 border rounded"/>
                    </div>
                    <div className="flex justify-end gap-2 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 font-semibold bg-gray-200 rounded-md">Cancelar</button>
                        <button type="submit" disabled={loading} className="px-4 py-2 font-semibold text-white bg-blue-600 rounded-md disabled:bg-blue-300">
                            {loading ? 'A guardar...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangeKeywordModal;